import * as React from 'react';
import { FormProvider, Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import StockForm from '../StockForm/StockForm';
import { STOCK_FORM_DEFAULT_VALUES } from '../StockForm/constants';
import { stockFormSchema } from '../StockForm/StockForm.schema';
import { TStockFormValues } from '../StockForm/StockForm.types';
import { TStockAdd } from './StockAdd.types';
import { useModals } from 'hooks/useModals';
import { useAppDispatch, useAppSelector } from 'store/store';
import {
  createStockAsyncThunk,
  getStockListAsyncThunk,
} from 'store/stock/stock.action';

const StockAdd: TStockAdd = () => {
  const dispatch = useAppDispatch();
  const modals = useModals();
  const { isLoading: isCreateStockLoading } = useAppSelector(
    (store) => store.stock.createStock
  );

  const form = useForm<TStockFormValues>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues: STOCK_FORM_DEFAULT_VALUES,
    resolver: yupResolver(stockFormSchema) as Resolver<TStockFormValues>,
  });

  const handleSubmit = (data: TStockFormValues) => {
    dispatch(
      createStockAsyncThunk({
        body: {
          ...data,
          variation: data.variation || undefined,
        },
        onSuccess: () => {
          modals.closeModal();
          dispatch(
            getStockListAsyncThunk({
              queryParams: { page: 1, perPage: 1000 },
            })
          );
        },
      })
    );
  };

  return (
    <FormProvider {...form}>
      <StockForm onSubmit={handleSubmit} isLoading={isCreateStockLoading} />
    </FormProvider>
  );
};

export default StockAdd;
